import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Wallet } from "@ethersproject/wallet";

import { Decimal, Difference, Trove } from "@liquity/lib-base";
import { LiquityStoreProvider } from "@liquity/lib-react";

import { useLiquity } from "./hooks/LiquityContext";
import { AppStateProvider } from "./hooks/AppStateContext";
import { TransactionMonitor } from "./components/Transaction";
import { UserAccount } from "./components/UserAccount";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

import { Dashboard } from "./pages/Dashboard";
import { ProductList } from "./pages/ProductList";
import { Product } from "./pages/Product";
import { StabilityPoolList } from "./pages/StabilityPoolList";
import { StabilityPool } from "./pages/StabilityPool";
import { RiskyTrovesPage } from "./pages/RiskyTrovesPage";
import { Faucet } from "./pages/Faucet";

import { TroveViewProvider } from "./components/Trove/context/TroveViewProvider";
import { StabilityViewProvider } from "./components/Stability/context/StabilityViewProvider";
import "tippy.js/dist/tippy.css"; // Tooltip default style
import { PageTracking } from "./components/PageTracking";

type LiquityFrontendProps = {
  loader?: React.ReactNode;
};
export const LiquityFrontend: React.FC<LiquityFrontendProps> = ({ loader }) => {
  const { account, provider, liquity } = useLiquity();

  // For console tinkering ;-)
  Object.assign(window, {
    account,
    provider,
    liquity,
    Trove,
    Decimal,
    Difference,
    Wallet
  });

  return (
    <LiquityStoreProvider {...{ loader }} store={liquity.store}>
      <Router>
        {process.env.NODE_ENV === "production" && (
          <PageTracking />
        )}
        <AppStateProvider>
          <TroveViewProvider>
            <StabilityViewProvider>
              <div className="flex flex-col h-screen justify-between">
                <Header>
                  <UserAccount />
                  {/* NOTE: Show when totalCollateralRatio is below price
                  <SystemStatsPopup /> */}
                </Header>

                <div className="flex flex-col items-center bg-main h-full pt-20 overflow-y-scroll">
                  <div className="container flex flex-row h-full p-4 py-6 md:px-0 mx-auto">
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/products" element={<ProductList />} />
                      <Route path="/products/:collateralAddress" element={<Product />} />
                      <Route path="/stability-pools" element={<StabilityPoolList />} />
                      <Route path="/stability-pools/:spAddress" element={<StabilityPool />} />
                      <Route path="/risky-troves" element={<RiskyTrovesPage />} />
                      <Route path="/faucet" element={<Faucet />} />
                    </Routes>
                  </div>
                </div>
                <Footer/>
              </div>
            </StabilityViewProvider>
          </TroveViewProvider>
        </AppStateProvider>
      </Router>
      <TransactionMonitor />
    </LiquityStoreProvider>
  );
};
